/*
 * Notification service to emit errors and other notifications to the notifications component
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from '@angular/core';
import {
  Observable,
  Subject
} from 'rxjs';
import {Notification, NotificationConfig} from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private subject = new Subject<Notification | string>();

  constructor() { }

  addNotification(type: string, content: any, config?: NotificationConfig): void {
    this.subject.next({
      type,
      content,
      config
    });
  }

  clearAll(): void {
    this.subject.next('clear');
  }

  get notifications(): Observable<any> {
    return this.subject;
  }
}
